<template>
    <ValidationProvider
        :name="$t('formularios.tipo_identificacion') + (index > 0 ? (' ' + index) : '')"
        :rules="required ? 'required' : ''"
        v-slot="{ errors }"
    >
        <div class="form-group">
            <label>{{ $t('formularios.tipo_identificacion') }}</label>
            <multiselect
                v-model="localType"
                label="label"
                track-by="type"
                class="custom-multiselect"
                :disabled="disabled"
                :class="{ 'is-invalid': errors.length }"
                :id="'tipo-documento-' + index"
                :data-cy="'tipo-documento-' + index"
                :placeholder="$t('formularios.tipo_identificacion')"
                :options="tiposDocumento"
                @input="onSelect"
            />
            <span
                v-if="errors[0]"
                class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold"
            >
                {{ errors[0] }}
            </span>
        </div>
    </ValidationProvider>
</template>

<script setup>

    import { ref, watch } from 'vue';

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        }
    });

    const emit = defineEmits(['input']);

    const tiposDocumento = [
        { type: 'DNI', label: 'DNI' },
        { type: 'NIE', label: 'NIE'},
        { type: 'NIF', label: 'NIF' },
        { type: 'PASAPORTE', label: 'PASAPORTE' },
        { type: 'OTROS', label: 'OTROS' }
    ];

    const localType = ref(
        tiposDocumento.find(opt => opt.type === props.value) || null
    );

    watch(() => props.value, newVal => {
        const match = tiposDocumento.find(opt => opt.type === newVal);
        if (localType.value?.type !== newVal) {
            localType.value = match || null;
        }
    });

    const onSelect = option => {
        localType.value = option;
        emit('input', option ? option.type : '');
    };
</script>
